import { args } from '../common/args';
import { defineCapability } from './internal';
export const TOGGLE_FULLSCREEN_MODE_CAP = defineCapability({
  name: 'TOGGLE_FULLSCREEN_MODE_CAP',
  args: {
    nextValue: args.optional(args.bool())
  }
});